<template>
    <div v-if="penjualanTembakau">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ penjualanTembakau.id ? 'Informasi' : 'Konfirmasi' }} Penjualan Tembakau</h5>
            </b-card-header>
            <b-card-body>
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Gudang</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ penjualanTembakau.gudang.name }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Tanggal Penjualan</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatDate(penjualanTembakau.created_at) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Pembeli</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ penjualanTembakau.pembeli }}</th>
                        </tr>
                        <tr v-if="penjualanTembakau.pengurang_status" class="text-danger">
                            <th class="fit-column">Pengurang (-)</th>
                            <td class="fit-column">:</td>
                            <th>{{ formatNumber(penjualanTembakau.pengurang) }}%</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Berat Total</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(penjualanTembakau.berat_akhir) }}</th>
                        </tr>
                        <tr v-if="penjualanTembakau.pajak_status" class="text-info">
                            <th class="fit-column">Pajak (-)</th>
                            <td class="fit-column">:</td>
                            <th>{{ formatNumber(penjualanTembakau.pajak) }}%</th>
                        </tr>
                        <tr v-if="penjualanTembakau.admin_status" class="text-info">
                            <th class="fit-column">Admin (-)</th>
                            <td class="fit-column">:</td>
                            <th>{{ formatNumber(penjualanTembakau.admin) }}</th>
                        </tr>
                        <template v-if="penjualanTembakau.potongan_status">
                            <tr class="text-info">
                                <th class="fit-column">Potongan (-)</th>
                                <td class="fit-column">:</td>
                                <th>{{ penjualanTembakau.potongan_notes ? penjualanTembakau.potongan_notes : formatNumber(penjualanTembakau.potongan) }}</th>
                            </tr>
                            <tr v-if="penjualanTembakau.potongan_notes" class="text-info">
                                <th class="fit-column"></th>
                                <td class="fit-column"></td>
                                <th>{{ formatNumber(penjualanTembakau.potongan) }}</th>
                            </tr>
                        </template>
                        <template v-if="penjualanTembakau.bonus_status">
                            <tr class="text-warning">
                                <th class="fit-column">Bonus (+)</th>
                                <td class="fit-column">:</td>
                                <th>{{ penjualanTembakau.bonus_notes ? penjualanTembakau.bonus_notes : formatNumber(penjualanTembakau.bonus) }}</th>
                            </tr>
                            <tr v-if="penjualanTembakau.bonus_notes" class="text-warning">
                                <th class="fit-column"></th>
                                <td class="fit-column"></td>
                                <th>{{ formatNumber(penjualanTembakau.bonus) }}</th>
                            </tr>
                        </template>
                        <tr>
                            <th class="fit-column">Total Harga</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(penjualanTembakau.total) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Pembayaran DP</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(penjualanTembakau.dp) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Metode Pembayaran</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ penjualanTembakau.metode_pembayaran && penjualanTembakau.metode_pembayaran.name ? penjualanTembakau.metode_pembayaran.name : penjualanTembakau.metode_pembayaran }}</th>
                        </tr>
                        <tr v-if="penjualanTembakau.total_pelunasan">
                            <th class="fit-column">Total Pelunasan</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(penjualanTembakau.total_pelunasan) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Kekurangan</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ penjualanTembakau.kekurangan <= 0 ? '-' : formatNumber(penjualanTembakau.kekurangan) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Keterangan</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ penjualanTembakau.keterangan }}</th>
                        </tr>
                        <tr v-if="isPelunasan">
                            <th class="fit-column">Pelunasan</th>
                            <td class="fit-column">:</td>
                            <th v-if="isKonfirmasiPelunasan" class="text-primary">{{ formatNumber(penjualanTembakau.pelunasan) }}</th>
                            <td v-else class="text-primary">
                                <input v-validate="'required|min_value:0'" min="0" v-model="penjualanTembakau.pelunasan" type="number" name="pelunasan" class="form-control">
                                <span class="text-danger">{{ errors.first('pelunasan') }}</span>
                            </td>
                        </tr>
                        <tr v-if="isPelunasan">
                            <th class="fit-column">Metode Pelunasan</th>
                            <td class="fit-column">:</td>
                            <th v-if="isKonfirmasiPelunasan" class="text-primary">{{ penjualanTembakau.metode_pelunasan && penjualanTembakau.metode_pelunasan.name ? penjualanTembakau.metode_pelunasan.name : penjualanTembakau.metode_pelunasan }}</th>
                            <td v-else>
                                <div class="input-group single mb-0 d-flex">
                                    <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode_pelunasan" v-model="penjualanTembakau.metode_pelunasan" :options="metodeOptions" :placeholder="'Pilih'" :searchable="true"
                                        label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                                </div>
                                <span class="text-danger">{{ errors.first('metode_pelunasan') }}</span>
                            </td>
                        </tr>
                    </table>
                </div>

                <template v-if="penjualanTembakau.kemasans">
                    <label class="form-control-label mt-3 pl-1">
                        Detail Barang
                    </label>
                    <div class="table-responsive">
                        <table class="table">
                            <tr>
                                <th>Kode</th>
                                <th>Grade</th>
                                <th>Berat</th>
                                <th>Harga/kg</th>
                                <th>Total Harga</th>
                                <th v-if="!isKonfirmasi && !isKonfirmasiPelunasan"></th>
                            </tr>
                            <tr v-for="item in penjualanTembakau.kemasans">
                                <th class="text-primary pl-0">
                                    {{ formatValue(item.code) }}
                                </th>
                                <th class="text-primary">
                                    {{ item.grade ? item.grade.name : '-' }}
                                </th>
                                <th class="text-primary">
                                    {{ item.latest_bobot ? formatNumber(item.latest_bobot) + ' KG' : '-' }}
                                </th>
                                <th class="text-primary">
                                    {{ formatNumber(item.harga) }}
                                </th>
                                <th class="text-primary">
                                    {{ formatNumber(parseInt(item.latest_bobot) * parseInt(item.harga)) }}
                                </th>
                                <th v-if="!isKonfirmasi && !isKonfirmasiPelunasan" class="fit-column text-center">
                                    <button :disabled="isLoading" type="button" title="Print QrCode" @click="printQrCode(item.pembelian_tembakau)" class="btn btn-link px-1"><i class="fas fa-print"></i></button>
                                </th>
                            </tr>
                        </table>
                    </div>
                </template>

                <template v-if="penjualanTembakau.pelunasans">
                    <label class="form-control-label mt-3 pl-1">
                        Detail Pelunasan
                    </label>
                    <div class="table-responsive">
                        <table class="table">
                            <tr>
                                <th>Tanggal</th>
                                <th>Nominal</th>
                                <th>Metode</th>
                            </tr>
                            <tr v-for="item in penjualanTembakau.pelunasans">
                                <th class="text-primary pl-0">
                                    {{ formatDatetime(item.created_at) }}
                                </th>
                                <th class="text-primary">
                                    {{ formatNumber(item.nominal) }}
                                </th>
                                <th class="text-primary">
                                    {{ item.metode_pembayaran }}
                                </th>
                            </tr>
                        </table>
                    </div>
                </template>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="!isKonfirmasi && !isKonfirmasiPelunasan" @click="isLoading = true; $emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('koreksi')" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('saved')" type="button" class="btn btn-primary mr-2">OK</button>
                <button :disabled="isLoading" v-if="isKonfirmasiPelunasan" @click="isKonfirmasiPelunasan = false" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasiPelunasan" @click="savePelunasan" type="button" class="btn btn-primary mr-2">OK</button>
                <button :disabled="isLoading" v-if="isPelunasan && !isKonfirmasiPelunasan" @click="konfirmasiPelunasan" type="button" class="btn btn-primary mr-2">Simpan</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi && !isPelunasan" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: "penjualan-tembakau-viewer",

    props: {
        isKonfirmasi: {
            type: Boolean,
            default: false,
        },

        isPelunasan: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        },
    },

    components: {
        Multiselect,
    },

    data() {
        return {
            penjualanTembakau: null,
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
            isKonfirmasiPelunasan: false,
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initPenjualan();
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.initPenjualan();
        }
    },

    methods: {
        initPenjualan() {
            let self = this;

            self.penjualanTembakau = Object.assign({}, self.value);
            self.penjualanTembakau.kemasans.forEach(kemasan => {
                kemasan.code = kemasan.pembelian_tembakau ? kemasan.pembelian_tembakau.code : kemasan.code;
                kemasan.latest_bobot = kemasan.bobot;
            });
        },

        print() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/penjualan-tembakaus/print/'+self.penjualanTembakau.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        save() {
            let self = this;
            self.$emit('saved', response.data.data);
        },

        konfirmasiPelunasan() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasiPelunasan = true;
                }
            });
        },

        savePelunasan() {
            let self = this;

            self.isLoading = true;
            let data = {
                penjualan_tembakau_id: self.penjualanTembakau.id,
                nominal: self.penjualanTembakau.pelunasan,
                metode_pembayaran: self.penjualanTembakau.metode_pelunasan ? self.penjualanTembakau.metode_pelunasan.name : null,
            }

            self.$Progress.start();
            axios({
                method: 'post',
                url: '/api/penjualan-tembakaus/pelunasan',
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved');
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        printQrCode(data) {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/pembelian-tembakaus/print/' + data.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
